// Zod для всех схем контрактов — с общей настройкой jitless: без eval (FR-043а, T107). CSP
// рабочего приложения — script-src 'self', без 'unsafe-eval'. Zod 4 ускоряет разбор объектов
// кодом из new Function и при создании первой схемы объекта пробует, можно ли так: под строгой
// CSP проба — нарушение (событие securitypolicyviolation), хотя ошибку Zod гасит. jitless
// отключает и ускорение, и пробу. Настройка стоит здесь, а не во входе приложения: модуль со
// схемой импортирует этот файл, поэтому настройка выполняется раньше любой схемы при любой
// раскладке сборки по частям. Схемы контрактов берут z только отсюда, не из 'zod'.
import { z } from 'zod';

z.config({ jitless: true });

export { z };
